import api from './api';

export interface ServicoPrazo {
  id: string | null;
  tipoPacoteId: string,
  codigo: number,
  nome: string,
  prazo: number,
  notifications: string[],
  invalid: boolean,
  valid: boolean
}

export const getAllServicoPrazos = () => api.get<ServicoPrazo[]>(`prazostipopacote`);

export const updateServicoPrazo = async (record: ServicoPrazo) => {
  console.log({ record })

  if (!record.id) {
    const data = {
      TipoPacoteId: record.tipoPacoteId,
      Prazo: record.prazo
    }

    return api
      .post<boolean>(`prazostipopacote`, data)
      .then(result => true)
      .catch(err => false);
  } else {
    const data = {
      Prazo: record.prazo
    }

    return api
      .put<boolean>(`prazostipopacote/${record.id}`, data)
      .then(result => true)
      .catch(err => false);
  }
};

/* export const getAllDisciplinas = () => api.get<TipoPacote[]>(`tipospacote/disciplinas`);
export const getAllTipos = () => api.get<TipoPacote[]>(`tipospacote/tipos`);

export const createDisciplina = (tipoPacote: Omit<TPData, 'codigo'>) =>
  api.post<TipoPacote>(`tipospacote/disciplinas`, tipoPacote);

export const createTipo = (tipoPacote: Omit<TPData, 'codigo'>) => api.post<TipoPacote>(`tipospacote/tipos`, tipoPacote);

export const updateDisciplina = (tipoPacote: any) => {
  const data = {
    id: tipoPacote.id,
    nome: tipoPacote.data.nome,
  };

  return api
    .put<boolean>(`tipospacote/disciplinas/${data.id}`, data)
    .then(result => true)
    .catch(err => false);
};

export const updateTipo = (tipoPacote: any) => {
  const data = {
    id: tipoPacote.id,
    nome: tipoPacote.data.nome,
  };

  return api
    .put<boolean>(`tipospacote/tipos/${data.id}`, data)
    .then(result => true)
    .catch(err => false);
};

export const deleteDisciplina = (id: string) => api.delete(`tipospacote/disciplinas/${id}`);
export const deleteTipo = (id: string) => api.delete(`tipospacote/tipos/${id}`);

export interface OrcamentoAcronimoPacote {
  ordemId: string;
  acronimoId: string;
  projetoId: string;
}

export const updateOrdemByAcronimoPacote = (ordemAcronimo: OrcamentoAcronimoPacote) => {
  return api
    .put<boolean>(`tipospacote/ordemInvestimento/${ordemAcronimo.ordemId}`, ordemAcronimo)
    .then(result => true)
    .catch(err => false);
};
 */